document.addEventListener('DOMContentLoaded', function () {

    // ── Constants ──
    var SCROLL_THRESHOLD = 8;       // px before nav gets "scrolled" styling

    // ── Elements ──
    var menuWrapper = document.getElementById('menuWrapper');
    var mobileMenu = document.getElementById('mobileMenu');
    var ticking = false;

    if (menuWrapper) {

        // ── Menu wrapper height CSS variable (for scroll offsets) ──
        function updateMenuHeight() {
            var menuHeight = menuWrapper.offsetHeight + 10;
            document.documentElement.style.setProperty('--menu-wrapper-height', menuHeight + 'px');
        }
        updateMenuHeight();
        window.addEventListener('resize', updateMenuHeight);

        // ── Scroll handler: "scrolled" class for visual styling ──
        function onScroll() {
            if (ticking) return;
            ticking = true;

            requestAnimationFrame(function () {
                var currentScrollY = window.scrollY;

                // iOS rubber-band: ignore negative scroll values
                if (currentScrollY < 0) {
                    ticking = false;
                    return;
                }

                // "scrolled" class — background, border, shadow
                if (currentScrollY > SCROLL_THRESHOLD) {
                    menuWrapper.classList.add('scrolled');
                } else {
                    menuWrapper.classList.remove('scrolled');
                }

                ticking = false;
            });
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll(); // Initialize on load
    }

    // ── Mobile Menu ──
    var menuToggle = document.getElementById('menuToggle');
    var menuClose = document.getElementById('menuClose');
    var mobileOverlay = document.getElementById('mobileOverlay');
    var mobileBottomBar = document.getElementById('mobileBottomBar');

    function openMobile() {
        if (mobileMenu) mobileMenu.classList.add('open');
        if (mobileOverlay) mobileOverlay.classList.add('open');
        if (mobileBottomBar) mobileBottomBar.style.display = 'none';
        document.body.style.overflow = 'hidden';
    }

    function closeMobile() {
        if (mobileMenu) mobileMenu.classList.remove('open');
        if (mobileOverlay) mobileOverlay.classList.remove('open');
        if (mobileBottomBar) mobileBottomBar.style.display = '';
        document.body.style.overflow = '';
    }

    if (menuToggle) menuToggle.addEventListener('click', openMobile);
    if (menuClose) menuClose.addEventListener('click', closeMobile);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobile);

    // Close mobile menu when clicking on a navigation link
    document.querySelectorAll('.mob-link').forEach(function (link) {
        link.addEventListener('click', closeMobile);
    });

    // ── Mobile Accordions ──
    document.querySelectorAll('.mob-accordion-toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var panel = btn.nextElementSibling;
            var icon = btn.querySelector('.mob-accordion-icon');
            var isOpen = panel.classList.contains('mob-accordion-open');

            // Close all other accordions
            document.querySelectorAll('.mob-accordion-panel.mob-accordion-open').forEach(function (p) {
                p.classList.remove('mob-accordion-open');
                p.style.maxHeight = null;
                var otherIcon = p.previousElementSibling.querySelector('.mob-accordion-icon');
                if (otherIcon) otherIcon.style.transform = '';
            });

            // Toggle current
            if (!isOpen) {
                panel.classList.add('mob-accordion-open');
                panel.style.maxHeight = panel.scrollHeight + 'px';
                if (icon) icon.style.transform = 'rotate(180deg)';
            }
        });
    });

    // ── Smooth scroll for anchor links ──
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
        a.addEventListener('click', function (e) {
            var href = a.getAttribute('href');
            if (href === '#') return;
            var target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth' });
                closeMobile();
            }
        });
    });

});
